export default "__VITE_ASSET__BEKouoY2__"